// Traducciones de presentación para el módulo Catálogo.
// Los valores internos de la API se mantienen en inglés para no romper la
// compatibilidad; aquí sólo traducimos la etiqueta visible al usuario.

export const PRODUCT_STATUS_LABEL = {
  draft: 'Borrador',
  published: 'Publicado',
  withdrawn: 'Retirado',
};

export const PUBLICATION_STATUS_LABEL = {
  draft: 'Borrador',
  validated: 'Validada',
  published: 'Publicada',
  rejected: 'Rechazada',
  withdrawn: 'Retirada',
};

export const REQUEST_STATUS_LABEL = {
  pending: 'Pendiente',
  granted: 'Concedida',
  denied: 'Denegada',
  revoked: 'Revocada',
};

export const TRANSACTION_STATUS_LABEL = {
  created: 'Creada',
  authorized: 'Autorizada',
  accessed: 'Accedida',
  completed: 'Completada',
  failed: 'Fallida',
  pending: 'Pendiente',
  denied: 'Denegada',
  revoked: 'Revocada',
};

export const PRODUCT_TYPE_LABEL = {
  contribution: 'Aportación',
  service: 'Servicio',
};

export const DECISION_LABEL = {
  auto_granted: 'Concesión automática',
  manual_granted: 'Concesión manual',
  manual_denied: 'Denegación manual',
};

export const t = (map, value) => (value == null ? '—' : (map[value] || value));
